import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import Wrapper from './style';
import theme, { colorScheme as scheme } from '../../configs/nivo';
import dataExample from './data.example';

const Index = (props) => {
  const { dataSource = dataExample, chartProps, colorScheme } = props;

  return (
    <Wrapper canvasHeight={chartProps?.canvasHeight}>
      <div className="component_line_canvas">
        <ResponsiveBar
          data={dataSource}
          theme={theme}
          keys={chartProps?.keys || ['burger', 'sandwich', 'kebab']}
          indexBy="id"
          margin={{
            top: 0,
            right: 0,
            bottom: 0,
            left: chartProps?.marginLeft || 40,
          }}
          groupMode={chartProps?.groupMode}
          layout={chartProps?.layout}
          padding={chartProps?.padding || 0.3}
          valueScale={{ type: 'linear' }}
          indexScale={{ type: 'band', round: true }}
          colors={colorScheme || { scheme: scheme.default }}
          axisTop={null}
          axisRight={null}
          axisBottom={null}
          axisLeft={
            chartProps?.axisLeft !== null
              ? {
                  tickSize: 0,
                  tickPadding: 8,
                  tickRotation: 0,
                  legend: '',
                  legendPosition: 'middle',
                  legendOffset: -13,
                }
              : null
          }
          borderRadius={chartProps?.borderRadius || 0}
          enableGridY={false}
          enableLabel={chartProps?.enableLabel !== false}
          innerPadding={chartProps?.innerPadding || 0}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={{ from: 'color', modifiers: [['darker', 3]] }}
          legends={
            chartProps?.legend || [
              {
                dataFrom: 'keys',
                anchor: 'bottom',
                direction: chartProps?.direction || 'row',
                justify: false,
                translateX: chartProps?.translateX || 0,
                translateY: chartProps?.translateY || 0,
                itemsSpacing: 1,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: chartProps?.itemDirection || 'left-to-right',
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                  {
                    on: 'hover',
                    style: {
                      itemOpacity: 1,
                    },
                  },
                ],
              },
            ]
          }
          role="application"
          ariaLabel="bar chart"
          barAriaLabel={(e) => {
            return `${e.id}: ${e.indexValue}`;
          }}
        />
      </div>
    </Wrapper>
  );
};

export default Index;
